import { message } from "antd";
import { auth, db, signInWithEmailAndPassword, signOut } from "./index";
import { decodeJWT } from "./decode-token";
import nookies from "nookies";
import { useEffect, useState } from "react";
import { UAParser } from "ua-parser-js";
import { ApolloClient, InMemoryCache } from "@apollo/client";
import { createHttpLink } from "apollo-link-http";
import fetch from "node-fetch";
import { setContext } from "apollo-link-context";
import { multiFactor, PhoneAuthProvider, PhoneMultiFactorGenerator, getMultiFactorResolver, onAuthStateChanged,RecaptchaVerifier, updatePassword,TotpMultiFactorGenerator,sendEmailVerification } from "firebase/auth";
import { getDoc, doc, setDoc} from "firebase/firestore";
import { AccountService } from "../../services/account";
import { updatePhoneNumber } from "firebase/auth";

const setSms = async (phoneNumber, recaptchaVerifier, uid, token) => {
  try {
    const multiFactorSession = await multiFactor(auth.currentUser).getSession();
    const phoneInfoOptions = {
      phoneNumber,
      session: multiFactorSession,
    };

    const phoneAuthProvider = new PhoneAuthProvider(auth);
    const verificationId = await phoneAuthProvider.verifyPhoneNumber(phoneInfoOptions, recaptchaVerifier);

    return { twoFARequired: true, uid: uid, verificationId: verificationId, phone: `***${phoneNumber.slice(-4)}`};
  } catch (e) {
    console.error("Error al enviar SMS:", e);
    message.error("Error al enviar el código 2FA.");
    await signOut(auth);
    const cookies = nookies.get(null);
    Object.keys(cookies).forEach((cookieName) => {
      nookies.destroy(null, cookieName, { path: "/" });
    });
    localStorage.clear();
  }
};

export const Guardar_numero = async (uid, phone, recaptchaVerifier) => {
  try {
    await setDoc(doc(db, "users", uid), { phoneNumber: phone }, { merge: true });
    message.success("Número de teléfono guardado. Procediendo con la autenticación 2FA.");
    await setSms(phone, recaptchaVerifier, uid);
  } catch (e) {
    console.error("Error al guardar el número de teléfono:", e);
    message.error("Error al guardar el número de teléfono.");
  }
};

export async function Authenticate(email, password, recaptchaVerifier) {

  if (!recaptchaVerifier) {
    message.error("Error: RecaptchaVerifier no inicializado.");
    return;
  }

  const loggingIn = message.loading("Iniciando sesión...");

  try {

    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    if(user.accessToken && decodeJWT(user.accessToken).role === "IMPLEMENTER_APP_USER"){
      await signOut(auth);
      const cookies = nookies.get(null);
      Object.keys(cookies).forEach((cookieName) => {
        nookies.destroy(null, cookieName, { path: "/" });
      });
      localStorage.clear();
      return { userApp: true, twoFARequired: false };
    }

    if (!user?.emailVerified) {
      const currentUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
      await sendEmailVerification(user,{
        url: currentUrl,
        handleCodeInApp: false
      });
      message.info("Por favor, verifica tu correo electrónico antes de continuar.");
      await signOut(auth);
      const cookies = nookies.get(null);
      Object.keys(cookies).forEach((cookieName) => {
          nookies.destroy(null, cookieName, { path: "/" });
      });
      localStorage.clear();
      return { emailNotVerified: true, twoFARequired: false };
  }

    let userDoc = await getDoc(doc(db, "users", user.uid));

    if (!userDoc.data()?.phoneNumber || !userDoc.exists()) {
      return { twoFARequired: false, uid: user.uid, NophoneNumber: true };
  }

    message.info(`Se requiere autenticación MFA. Enviando código al teléfono ****${userDoc.data().phoneNumber.slice(-4)}`);

    const result = await setSms(userDoc.data().phoneNumber, recaptchaVerifier, user.uid, user.accessToken);

    return {
      ...result,
    }

  } catch (e) {

    if (e.code === "auth/multi-factor-auth-required") {

      const resolver = getMultiFactorResolver(auth, e)
      const totpHint = resolver.hints.find(h => h.factorId === "totp");
      const smsHint = resolver.hints.find(h => h.factorId === "phone");

      const hints = resolver.hints.map(hint => ({
        factorId: hint.factorId,
        uid: hint.uid,
        displayName: hint.displayName,
        phoneNumber: hint.factorId === 'phone' ? hint.phoneNumber : null,
      }));
      if (hints.length > 1) {
        return {
          twoFARequired: true,
          multipleFactors: true,
          hints,
          resolver,
          email,
          password
        }
      }

      if (totpHint) {
        return {
          twoFARequired: true,
          type: "totp",
          resolver,
          hint: totpHint
        };
      }
    
      const phoneAuthProvider = new PhoneAuthProvider(auth)
      if (smsHint) {
        const verificationId = await phoneAuthProvider.verifyPhoneNumber(
          {
            multiFactorHint: smsHint,
            session: resolver.session
          },
          recaptchaVerifier
        )
    
        return {
          twoFARequired: true,
          type: "sms",
          verificationId,
          resolver,
          phone: smsHint.phoneNumber
        }
      }
    }

    console.error("Login error:", e);
    message.error(e.message);

  } finally {
    loggingIn();
  }

}

const  limpiarCredenciales =() =>{
  const cookies = nookies.get(null);
  Object.keys(cookies).forEach((cookieName) => {
    nookies.destroy(null, cookieName, { path: "/" });
  });
  localStorage.clear();
}


export const useDeviceInfo = () => {
  const [deviceInfo, setDeviceInfo] = useState(null);

  useEffect(() => {
    const parser = new UAParser();
    const result = parser.getResult();

    setDeviceInfo({
      os: result.os.name,
      browser: result.browser.name,
      device: result.device.type || "PC",
    });
  }, []);

  return deviceInfo;
};

export const useIpAddress = () => {
  const [location, setLocation] = useState(null);

  useEffect(() => {
    fetch("https://get.geojs.io/v1/ip/geo.json")
      .then((res) => res.json())
      .then((data) => {
        setLocation({
          ip: data.ip,
          city: data.city,
          region: data.region,
        });
      })
      .catch((error) => console.error("Error obteniendo IP:", error));
  }, []);

  return location;
};

const esperarUsuarioAutenticado = () => {
  return new Promise((resolve) => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        unsubscribe();
        resolve(user);
      }
    });
  });
};

export async function Verify2FACode(code, setIs2FA, email, password, ipInfo, { verificationId, resolver }) {
  try {
    if (!verificationId) {
      throw new Error("Falta el ID de verificación. Por favor, solicita un nuevo código.");
    }
    let user;
    
    const credential = PhoneAuthProvider.credential(verificationId, code);
    const multiFactorAssertion = PhoneMultiFactorGenerator.assertion(credential);

    if (resolver) {
      const userCredential = await resolver.resolveSignIn(multiFactorAssertion);
      user = userCredential.user;
    } else {
      const currentUser = auth.currentUser;
      if (!currentUser) throw new Error("No hay sesión iniciada.")
      await multiFactor(currentUser).enroll(multiFactorAssertion, currentUser.displayName)
      user = currentUser
    }

    const factors = multiFactor(user).enrolledFactors


    const hasTotp = factors.some(
      f => f.factorId === "totp"
    )


    if (!hasTotp) {
      return { enableTotp: true }
    }

    document.cookie = `2FAToken=true; path=/; secure; SameSite=Strict;`;

    message.success("Autenticación MFA exitosa!");

    const { role, exp, user_id } = decodeJWT(user.accessToken)
    
    const existingInfo = JSON.parse(
      localStorage.getItem("ipInfo") || "{}"
    );
    
    const deviceId =
      existingInfo.deviceId || crypto.randomUUID();

    const lastUsed = new Date().toISOString();
    localStorage.setItem("expTokenTime", exp);
    localStorage.setItem("ipInfo", JSON.stringify({ ...ipInfo, uid: user_id, deviceId, lastUsed }));

    let userSecurePass = await getDoc(doc(db, "secureUserPass", user_id));

    if(!userSecurePass.data()?.SecurePass || !userSecurePass.exists()){
      document.cookie = `secureUserPass=true; path=/; secure; SameSite=Strict;`;
      return { uid: user_id, NoSecurePass: true};
    }else{
      return {NoSecurePass:false, role }
    }

  } catch (error) {
    console.error("Error verificando código:", error);
    message.error(error.message || "Código incorrecto");

    await signOut(auth);
    const cookies = nookies.get(null);
    Object.keys(cookies).forEach((cookieName) => {
      nookies.destroy(null, cookieName, { path: "/" });
    });
    localStorage.clear();
    setIs2FA(false);
  }
}

export const generateTotp = async () => {
  try {
    const user = auth.currentUser
    if (!user) throw new Error("Usuario no autenticado")
  
    const multiFactorSession = await multiFactor(user).getSession()
  
    const totpSecret =
      await TotpMultiFactorGenerator.generateSecret(multiFactorSession)
  
    const qrCodeUrl = totpSecret.generateQrCodeUrl(
      user.email,
      "Ficosec"
    )
    
    return {
      totpSecret,
      qrCodeUrl
    }
  } catch (e) {

    console.error("Error generando TOTP:", error);
    throw error;
  }

}

export const recoveryPhone = async (phone, recaptchaVerifier) => {
  try {
    const user = auth.currentUser;

    if (!user) {
      message.error("Usuario no autenticado.");
      return { status: false };
    }

    if (!recaptchaVerifier) {
      message.error("No se ha inicializado la verificación reCAPTCHA.");
      return { status: false };
    }

    const session = await multiFactor(user).getSession();

    const phoneAuthProvider = new PhoneAuthProvider(auth);
    const verificationId = await phoneAuthProvider.verifyPhoneNumber(
      { phoneNumber: phone, session },
      recaptchaVerifier
    );

    return { status: true, id: verificationId };
  } catch (error) {
    console.error("Error en recoveryPhone:", error.code, error);

    if (error.code === "auth/requires-recent-login") {
      message.error("Por seguridad, vuelve a iniciar sesión e inténtalo de nuevo.");
    } else {
      message.error(error.message || "Error al enviar el código.");
    }
    return { status: false };
  }
}

export async function VerifyTotpCode(
  code,
  setIs2FA,
  ipInfo,
  resolver
) {
  try {

    const totpHint = resolver.hints.find(h => h.factorId === "totp");

    const multiFactorAssertion =
      TotpMultiFactorGenerator.assertionForSignIn(
      totpHint.uid,
      code
    )

    await resolver.resolveSignIn(multiFactorAssertion);

    const user = await esperarUsuarioAutenticado();

    document.cookie = `2FAToken=true; path=/; secure; SameSite=Strict;`;

    message.success("Autenticación MFA exitosa!");

    const { role, exp, user_id } = decodeJWT(user.accessToken);

    const existingInfo = JSON.parse(
      localStorage.getItem("ipInfo") || "{}"
    );
    
    const deviceId =
      existingInfo.deviceId || crypto.randomUUID();
    
    const lastUsed = new Date().toISOString();

    localStorage.setItem("expTokenTime", exp);
    localStorage.setItem(
      "ipInfo",
      JSON.stringify({
        ...ipInfo,
        uid: user_id,
        deviceId,
        lastUsed,
      })
    );

    let userSecurePass = await getDoc(doc(db, "secureUserPass", user_id));

    if (!userSecurePass.data()?.SecurePass || !userSecurePass.exists()) {
      document.cookie = `secureUserPass=true; path=/; secure; SameSite=Strict;`;
      return { uid: user_id, NoSecurePass: true };
    } else {
      return { NoSecurePass: false, role };
    }

  } catch (error) {

    console.error("Error verificando TOTP:", error);

    message.error("Código incorrecto");

    await signOut(auth);

    const cookies = nookies.get(null);

    Object.keys(cookies).forEach((cookieName) => {
      nookies.destroy(null, cookieName, { path: "/" });
    });

    localStorage.clear();

    setIs2FA(false);
  }
}

export const recoveryPhoneValidCode = async (code, verificationId) => {
  try {
    const user = auth.currentUser;
    const mf = multiFactor(user);

    const credential = PhoneAuthProvider.credential(verificationId, code);
    const assertion = PhoneMultiFactorGenerator.assertion(credential);

    const oldPhoneFactors = mf.enrolledFactors.filter(
      (f) => f.factorId === PhoneMultiFactorGenerator.FACTOR_ID
    );

    await mf.enroll(assertion, "Teléfono principal");

    for (const factor of oldPhoneFactors) {
      await mf.unenroll(factor);
    }

    await user.reload()

    message.success("Tu número de teléfono se actualizó correctamente.")

    return true;
  } catch (error) {
    console.error("[TELÉFONO]", error.code, error.message);
    if (error.code === "auth/requires-recent-login") {
      message.error("Por seguridad, vuelve a iniciar sesión e inténtalo de nuevo.");
    } else if (error.code === "auth/invalid-verification-code") {
      message.error("El código es incorrecto.");
    } else if (error.code === "auth/second-factor-already-in-use") {
      message.error("Este número ya está inscrito como segundo factor.");
    } else {
      message.error("No se pudo actualizar el teléfono.");
    }
    return false;
  }
}

export const updateUserPassword = async (newPassword) => {
  try {
    const user = auth.currentUser;
    if (!user) {
      message.error("No hay usuario autenticado.");
      return false;
    }

    await updatePassword(user, newPassword);

    await setDoc(
      doc(db, "secureUserPass", user.uid),
      { SecurePass: true },
      { merge: true }
    );

    message.success("Contraseña actualizada correctamente. Por favor vuelve a iniciar sesión");

    await signOut(auth);
    const cookies = nookies.get(null);
    Object.keys(cookies).forEach((cookieName) => {
      nookies.destroy(null, cookieName, { path: "/" });
    });
    localStorage.clear();

    return true;
  } catch (error) {
    console.error("Error al actualizar contraseña:", error);
    if (error.code === "auth/requires-recent-login") {
      message.error("Debes volver a iniciar sesión para cambiar tu contraseña.");
    } else {
      message.error("Error al actualizar la contraseña.");
    }
    return false;
  }
};

